module.exports = __webpack_public_path__ + "img/Step1.d5fc867d.png";